import React, {Component} from 'react';
import {API_BASE_URL} from '../../constants';
import $ from 'jquery';
class JobExternal extends Component {

    constructor(props) {
        super(props);
        this.initeachevent=this.initeachevent.bind(this);
    }

    componentDidMount(){
           this.initeachevent();
    }

      initeachevent(){

      $('#calendar-event .calendar-events').each(function() {

           var eventId=$(this).attr('id');
          // console.log(eventId);

            $(this).data('event', {
                title: $.trim($(this).text()),
                id:eventId,
                backgroundColor: $(this).data('bgcolor'),
                textColor: $(this).data('textcolor'),
                borderColor:$(this).data('bgcolor'),
                imageUrl:$(this).data('imageurl'),
                people:$(this).data('people'),
                stick: true
            });
            $(this).draggable({
                zIndex: 999,
                revert: true,
                revertDuration: 0
            });
        });

    }
   render(){

        return <div className="col-md-3">
            <div className="card">
                <div className="card-body">
                         <h6 className="card-title">Employee &nbsp;&nbsp;
                         </h6>

                         <div className="row" id="slimtest4">
                            <div className="col-md-12 col-sm-12 col-xs-12">
	                            <div id="calendar-event" className="m-t-20">

                               {this.props.peopleInfo.map((item, key) =>

                                   <div style={{borderColor:item.bgcolor,marginBottom:'3px',backgroundColor:item.bgcolor,color:item.textColor}}  className='calendar-events'  data-imageurl={item.profileLogo ? '/image/people/'+item.id+'/profileimage.jpg': ('')} data-bgcolor={item.bgcolor} data-textcolor={item.textColor} data-people={item.id} id={item.id} key={ key }>

                                          {item.profileLogo ? (
									         <img src={API_BASE_URL+'/image/people/'+item.id+'/profileimage.jpg'}  style={{borderRadius:'100%'}} height="30px" width="30px" alt="user"/>

									      ) : (
									          <img src="../static/assets/images/people.png"  style={{borderRadius:'100%'}} height="30px" width="30px" alt="user"/>

									      )}



                                         <i className="ti-menu threeline"></i>


                                   &nbsp;{item.name}
                                   </div>
                               )}
	                            </div>
                            </div>
                         </div>



                </div>
            </div>
        </div>;
  }
}
export default JobExternal
